import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { RouterProvider } from "react-router-dom";
import router from "./Router";
import { RecoilRoot } from "recoil";
import { CookiesProvider } from "react-cookie";
import * as serviceWorker from "./serviceWorker";

serviceWorker.unregister();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <RecoilRoot>
    <CookiesProvider>
      <RouterProvider router={router} />
    </CookiesProvider>
  </RecoilRoot>
);
